import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SiteHeader from "./components/omega/SiteHeader";
import SiteFooter from "./components/omega/SiteFooter";
import WhatsAppFab from "./components/omega/WhatsAppFab";
import MobileActionBar from "./components/omega/MobileActionBar";
import ScrollManager from "./components/ScrollManager";
import HomePage from "./pages/HomePage";
import PreciosPage from "./pages/PreciosPage";
import PortafolioPage from "./pages/PortafolioPage";
import SobrePage from "./pages/SobrePage";
import ContactoPage from "./pages/ContactoPage";
import SegmentoPage from "./pages/SegmentoPage";
import EntregaPage from "./pages/EntregaPage";
import AutorizacionPage from "./pages/AutorizacionPage";
import TrabajoPage from "./pages/TrabajoPage";
import { SEGMENTOS } from "./data/segmentos";
import { TRABAJOS } from "./data/trabajos";
import { ENTREGAS } from "./data/entregas";
import { rutaAutorizacion } from "./data/autorizacion";

const AppShell = () => (
    <div className="flex min-h-screen flex-col bg-sand-50">
      <ScrollManager />
      <SiteHeader />
      <main className="relative flex-grow pb-16 lg:pb-0">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/precios" element={<PreciosPage />} />
          <Route path="/portafolio" element={<PortafolioPage />} />
          {TRABAJOS.map((trabajo) => (
            <Route key={trabajo.path} path={trabajo.path} element={<TrabajoPage />} />
          ))}
          <Route path="/sobre-omega" element={<SobrePage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          {SEGMENTOS.map((segmento) => (
            <Route key={segmento.path} path={segmento.path} element={<SegmentoPage />} />
          ))}
          {ENTREGAS.map((entrega) => (
            <Route key={entrega.path} path={entrega.path} element={<EntregaPage />} />
          ))}
          {ENTREGAS.map((entrega) => (
            <Route key={rutaAutorizacion(entrega)} path={rutaAutorizacion(entrega)} element={<AutorizacionPage />} />
          ))}
        </Routes>
      </main>
      <SiteFooter />
      <WhatsAppFab />
    <MobileActionBar />
  </div>
);

const App = () => (
  <Router>
    <AppShell />
  </Router>
);

export default App;
